import script from "./MazdaReplacePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaReplacePanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaReplacePanel.vue?vue&type=style&index=0&id=520d30ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520d30ee"]])

export default __exports__